import React, { Component } from "react";
import { FixedWidth } from "../../CommonComponents/commonStyles";
import {
  FooterContainer,
  FooterContent,
  CopyRight,
  CopyRightLogo,
  Container1,
  SocialMediaIcon,
  CopyRightContent,
  BrandLogo,
  SocialMediaContainer,
  EndowmentRight,
  BrandLogoContainer
} from "./style";
import { Row, Col } from "antd";
import "../../Epics/AccountSummary/Pages/AccountSummary.css";
import brandLogo from "../../assets/icons/vcep-white.png";
import linkedin from "../../assets/icons/linkedin.png";
import copyRightLogo from "../../assets/icons/vangaurd-footer.png";
import { getpwUrl,initiateTracking, recordError } from "../../utils/commonUtil";
import moment from "moment";

export default class Footer extends Component {
  footerAnalytics = e => {
    initiateTracking("globalFooterDP", "Navigation", "Global Footer Navigation DP", e);
  }

  render() {
    let linkedinurl = "https://www.linkedin.com/company/vanguard-charitable";
    return (
      <footer id="footer" role="contentinfo">
        <FooterContainer>
          <FixedWidth>
            <Row>
              <Col md={12} sm={24} xs={24}>
                <Container1>
                  <BrandLogoContainer>
                    <BrandLogo src={brandLogo} alt="Vangaurd" />
                  </BrandLogoContainer>
                  <SocialMediaContainer
                    data-test="social-linkdin"
                    onClick={() => {
                      try {
                        window.open(linkedinurl);
                      } catch (error) {
                        recordError(error);
                      }
                    }}
                  >
                    <SocialMediaIcon src={linkedin} alt="social linkedIn" />
                    <span>Follow us on LinkedIn</span>
                  </SocialMediaContainer>
                  <EndowmentRight>
                    © {moment().format('YYYY')} Vanguard Charitable Endowment Program
                  </EndowmentRight>
                </Container1>
              </Col>
              <Col className="footerLinks" lg={6} md={6} sm={12} xs={12}>
                <FooterContent
                  data-test="aboutus"
                  onClick={() => {
                    try {
                      this.footerAnalytics('About Us');
                      window.open(getpwUrl() + "about-us");
                    } catch (error) {
                      recordError(error);
                    }
                  }}
                >
                  ABOUT US
                </FooterContent>
                <FooterContent
                  data-test="careers"
                  onClick={() => {
                    try {
                      this.footerAnalytics('Careers');
                      window.open(getpwUrl() + "careers");
                    } catch (error) {
                      recordError(error);
                    }
                  }}
                >
                  Careers
                </FooterContent>
                <FooterContent
                  data-test="faqs"
                  onClick={() => {
                    try {
                      this.footerAnalytics('Faqs');
                      window.open(getpwUrl() + "FAQs");
                    } catch (error) {
                      recordError(error);
                    }
                  }}
                >
                  Faqs
                </FooterContent>
                <FooterContent
                  data-test="contact-us"
                  onClick={() => {
                    try {
                      this.footerAnalytics('Contact us');
                      window.open(getpwUrl() + "contact-us");
                    } catch (error) {
                      recordError(error);
                    }
                  }}
                >
                  Contact us
                </FooterContent>
                <FooterContent
                  data-test="giving-matters-blog"
                  onClick={() => {
                    try {
                      this.footerAnalytics('Giving Matters Blog');
                      window.open(getpwUrl() + "blog");
                    } catch (error) {
                      recordError(error);
                    }
                  }}
                >
                  GIVING MATTERS BLOG
                </FooterContent>
                <FooterContent
                  data-test="news-and-events"
                  onClick={() => {
                    try {
                      this.footerAnalytics('News And Events');
                      window.open(getpwUrl() + "news");
                    } catch (error) {
                      recordError(error);
                    }
                  }}
                >
                  News &amp; Events
                </FooterContent>
                <FooterContent
                  data-test="newsroom"
                  onClick={() =>{
                    try {
                      this.footerAnalytics('News Room');
                      window.open(getpwUrl() + "newsroom");
                    } catch (error) {
                      recordError(error);
                    }
                  }}
                >
                  NewsRoom
                </FooterContent>
              </Col>
              <Col
                className="footerLinks"
                lg={6}
                md={6}
                sm={11}
                xs={{ span: 11 }}
              >
                <FooterContent
                  data-test="terms-and-conditions"
                  onClick={() =>{
                    try {
                      this.footerAnalytics('Terms And Conditions');
                      window.open(
                        getpwUrl() + "company-policies/terms-and-conditions"
                      );
                    } catch (error) {
                      recordError(error);
                    }
                  }}
                >
                  TERMS &amp; CONDITIONS
                </FooterContent>
                <FooterContent
                  data-test="sitemap"
                  onClick={() => {
                    try {
                      this.footerAnalytics('Sitemap');
                      window.open(getpwUrl() + "sitemap");
                    } catch (error) {
                      recordError(error);
                    }
                  }}
                >
                  SITEMAP
                </FooterContent>
                <FooterContent
                  data-test="forms"
                  onClick={() => {
                    try {
                      this.footerAnalytics('Forms');
                      window.open(getpwUrl() + "forms");
                    } catch (error) {
                      recordError(error);
                    }
                  }}
                >
                  FORMS
                </FooterContent>
                <FooterContent
                  data-test="request-litrature"
                  onClick={() =>{
                    try {
                      this.footerAnalytics('Request Literature');
                      window.open(getpwUrl() + "forms/request-literature");
                    } catch (error) {
                      recordError(error);
                    }
                  }}
                >
                  Request Literature
                </FooterContent>
                <FooterContent
                  data-test="policies-and-guidelines"
                  onClick={() =>{
                    try {
                      this.footerAnalytics('Policies And Guidelines');
                      window.open(
                        getpwUrl() + "company-policies/policies-and-guidelines"
                      );
                    } catch (error) {
                      recordError(error);
                    }                   
                  }}
                >
                  Policies &amp; Guidelines
                </FooterContent>
                <FooterContent
                  data-test="privacy-policy"
                  onClick={() =>{
                    try {                      
                      this.footerAnalytics('Privacy Policy');
                      window.open(getpwUrl() + "company-policies/Privacy-Policy");
                    } catch (error) {
                      recordError(error);
                    }
                  }}
                >
                  Privacy policy
                </FooterContent>
                <FooterContent
                  data-test="company-policies"
                  onClick={() => {
                    try {
                      this.footerAnalytics('Company Policies');
                      window.open(getpwUrl() + "company-policies");
                    } catch (error) {
                      recordError(error);
                    }
                  }}
                >
                  Company policies
                </FooterContent>
              </Col>
            </Row>
          </FixedWidth>
        </FooterContainer>
        <CopyRight>
          <FixedWidth>
            <Row>
              <CopyRightLogo
                src={copyRightLogo}
                alt="VANGUARD and the Vanguard Ship"
              />
            </Row>
            <Row>
              <CopyRightContent>
                © {moment().format('YYYY')} Vanguard Charitable Endowment Program. VANGUARD is a trademark of The Vanguard Group, Inc.
              </CopyRightContent>
            </Row>
          </FixedWidth>
        </CopyRight>
      </footer>
    );
  }
}
